import * as React from "react"
import TextInput from "react-autocomplete-input"
import { AppState } from "../../store/types"
import { useSelector } from "react-redux"
import "react-autocomplete-input/dist/bundle.css"
import { setFacilityName } from "../../store/devdocs/actions"
import { useDispatch } from "react-redux"
import { getOrderCalculation } from "../../utils/getOrderCalculation"
import { getChartData } from "../../utils/getChartData"
import ChartType from "../../enums/ChartType"
import { getFullYearData } from "../../utils/getFullYearData"

export interface ILocationSelectorProps {
  chartType: ChartType
}

export function LocationSelector(props: ILocationSelectorProps) {
  const { chartType } = props
  const { locations, dateTime } = useSelector(
    (state: AppState) => state.devDocs
  )
  const dispatch = useDispatch()

  return (
    <div className="mx-auto">
      <TextInput
        id="locationInput"
        trigger={[""]}
        options={locations}
        spacer={""}
        placeholder={"Haltestelle"}
        onSelect={value => {
          dispatch(setFacilityName(value))
          if (chartType === ChartType.DAILY) {
            getOrderCalculation(dateTime, value)
            getChartData(dateTime, value)
          } else {
            getFullYearData(value)
          }
        }}
      />
    </div>
  )
}
